package navigation.home.clients.addeditclient

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.client.ui.addeditclient.AddEditClientEvent
import com.essntl.features.client.ui.addeditclient.AddEditClientState
import com.essntl.features.client.ui.addeditclient.AddEditClientValidation
import com.essntl.features.client.ui.addeditclient.AddEditClientViewModel
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.toastmanager.ToastManager

class AddEditClientScreenModel(
    clientRepository: ClientRepository,
    proposalRepository: ProposalRepository,
    itineraryRepository: ItineraryRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditClientState>(AddEditClientState()) {
    val validation = AddEditClientValidation()

    private val addEditClientViewModel =
        AddEditClientViewModel(
            clientRepository = clientRepository,
            proposalRepository = proposalRepository,
            itineraryRepository = itineraryRepository,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AddEditClientEvent) {
        addEditClientViewModel.onEvent(event)
    }
}
